import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonWild } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWild"

import ThumbnailSlider from "../thumbnailslider/thumbnailslider"

const Wrapper = styled.div`
  border-radius: 8px;
  padding: 0 0 32px;

  @media (min-width: ${theme.mediaqueries.small}) {
    padding: 0 10px 40px;
  }

  @media (min-width: ${theme.mediaqueries.medium}) {
    padding: 0 40px 80px;
  }

  @media (min-width: ${(props) => props.breakpoint}) {
    background: transparent;
    padding: 0;
    margin-bottom: 0;
  }
`

const TitleWrapper = styled(Box)``

const ButtonWrapper = styled(Box)``

const ThumbnailWrapper = styled(Box)`
  @media (min-width: ${(props) => props.breakpoint}) {
    display: none;
  }
`

const ResultsHeader = ({
  breakpoint = theme.mediaqueries.small,
  title,
  button,
  slides,
}) => (
  <Wrapper breakpoint={breakpoint}>
    {title ? (
      <TitleWrapper
        maxWidth={title.maxWidth || "none"}
        mb={title.mb || [32, 32, 40]}
        mx="auto"
      >
        <TextElementNova
          element={title.element || "h2"}
          text={title.text}
          className={`Title-20-Super-Normal text-center`}
          styles={title.styles}
        />
      </TitleWrapper>
    ) : null}
    {button ? (
      <ButtonWrapper
        mb={button.mb || [24, 24, 32, 40]}
        mx="auto"
        className="text-center"
      >
        <ButtonWild
          primary
          textLink
          arrowRight
          label={button.label}
          ctaLink={button.url}
          trackObject={{
            destination: button.url,
            module_location: button.moduleLocation,
            text: button.label,
            type: "link",
          }}
        />
      </ButtonWrapper>
    ) : null}
    <ThumbnailWrapper
      breakpoint={breakpoint}
      //maxWidth={["calc(100% - 48px)", "calc(100% - 48px)", 712]}
      maxWidth={[null, null, 712]}
      mx="auto"
    >
      <ThumbnailSlider slides={slides} />
    </ThumbnailWrapper>
  </Wrapper>
)

export default ResultsHeader
